<template>
  <div class="card" :style="{marginBottom: marginBottom + 'px'}">
    <div class="title" >
      {{title}}
      <div class="custom">
        <slot name="custom" />
      </div>
    </div>
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    marginBottom: {
      type: Number,
      default: 6
    }
  }
}
</script>



<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  color: #303133;
  padding: 15px;
  border: 1px solid #ebeef5;
  background-color: #ffffff;
  overflow: hidden;
  transition: 0.3s;
  border-radius: 4px;
  .title {
    color: #333333;
    height: 38px;
    font-weight: 500;
    .custom {
      display: inline-block;
      color: #99c41c;
      font-weight: 400;
      margin-left: 8px;
    }
  }
  .body {
    flex: 1;
  }
}
</style>